import { useContext } from "react";
import { Modal } from "react-bootstrap";
import { MessageContext } from "./Contex";
import InfoIcon from "../../../../assets/img/carga duplicada.svg";
import InfoErrorIcon from "../../../../assets/img/carga excedida.svg";
import ErrorIcon from "../../../../assets/img/error-icon.png";
import SuccessIcon from "../../../../assets/img/Icono_sucess.png";
import "./download-message.css";

/**
 * Modal download message
 */

export const ModalDownloadMessageComponent = ({
  visible = false,
  onToggle,
  success = false,
}) => {
  const responseData = useContext(MessageContext);
  const closeButtonText = responseData?.buttonText || "Cerrar";
  const hasMessage2 = Boolean(responseData?.message2?.trim());

  return (
    <Modal
      show={visible}
      centered
      onHide={onToggle}
      dialogClassName="modal-download-dialog-size"
      backdrop="static"
    >
      <div className="success-modal">
        <div className="download-modal-content">
          <Modal.Body className="connection-modal-body-modal-download">
            <div
              className={`connection-status-container-modal-download${
                hasMessage2 ? " has-message2" : ""
              }`}
            >
              <div className="connection-icon-container-modal-download">
                {responseData?.icon === "loading" ? (
                  <span
                    className="download-timeout-spinner"
                    aria-hidden="true"
                  />
                ) : (
                  <img
                    src={
                      responseData?.icon === "error"
                        ? ErrorIcon
                        : responseData?.icon === "success"
                          ? SuccessIcon
                          : responseData?.icon === "info"
                            ? InfoIcon
                            : responseData?.icon === "alert-info-red"
                              ? InfoErrorIcon
                              : ErrorIcon
                    }
                    alt="Message"
                  />
                )}
              </div>

              <div className="download-modal-text-block">
                <h4 className="connection-title-modal-download">
                  {responseData?.message}
                </h4>
                {hasMessage2 ? (
                  <p className="connection-description-modal-download">
                    {responseData.message2}
                  </p>
                ) : null}
              </div>

              <div className="connection-actions-modal-download">
                <div
                  className="btn-modal-download btn-hb-primary-without-border-modal-download"
                  onClick={() => onToggle()}
                >
                  {closeButtonText}
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </div>
    </Modal>
  );
};